import styled from 'styled-components';
import {
  darken,
} from 'polished';
import {
  NavLink,
} from 'react-router-dom';
import {
  SVG,
} from 'web-styled';

export const Link = styled(NavLink)`
  display: block;
  background-color: #fff;
  border: 1px solid ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.primary};
  padding: 8px 29px;
  border-radius: 50px;
  transition: all 0.2s linear;

  &:hover {
    color: ${props => darken(0.05, props.theme.colors.primary)};
    border-color: ${props => darken(0.05, props.theme.colors.primary)};
    background-color: #fff;
  }
`;

export const CounterProgress = styled.div`
  width: 85px;
  height: 150px;
  svg {
    width: 100%;
    height: 100%;
  }
`;

export const PositiveDynamic = styled(SVG.PositiveDynamic).attrs(
  props => ({
    fill: props.theme.colors.completed,
  }),
)``;

export const NegativeDynamic = styled(SVG.NegativeDynamic).attrs(
  props => ({
    fill: props.theme.colors.notCompleted,
  }),
)``;
